import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCard from '../shared/SectionCard'
import './style.css'
import { FileUploadField } from '../shared'
import { GetProviderProfileExternalData, UploadProviderPricing } from '@/api/endpoints/ProviderProfile'
import { usePost } from '@/api/hooks'
import ActionBtn from '@/components/ActionBtn'
import { errToast } from '@/utils'

const EditSpecialties = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    const { onPost: onUploadSheet, isPending: isUploading } = usePost(UploadProviderPricing)

    const submitPricing =()=>{

        if(!formHandler.formValues.specialtiesPricing)
            return errToast(t("please-select-file"))

      const formData =  new FormData()

      formData.append('file', formHandler.formValues.specialtiesPricing[0])



      onUploadSheet({formData})

    }

    const getSheet =()=>{
        GetProviderProfileExternalData().then(response=>{
            console.log(response)
        })
        .catch(error=>{
            console.log(error)
        })
    }

    return (
        <SectionCard
            title={t("specialties")}
            icon="mdi:category-plus-outline"
            className="edit-specialties"
        >
            <div className="edit-form-grid">
                <div className="form-field full-width">

                    <div className="specialties-sheet-actions">
                        <ActionBtn
                            title="sheet-template"
                            onApply={getSheet}
                            icon="line-md:download"
                            className="btn-primary sheet-btn"
                        />
                        <ActionBtn
                            title="upload-prices-sheet"
                            onApply={submitPricing}
                            isDisabled={isUploading}
                            icon="mdi:plus"
                            className="btn-primary sheet-btn"
                        />
                    </div>
                    <FileUploadField
                        formHandler={formHandler.handleFormValues}
                        name="specialtiesPricing"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        multiple
                        maxFiles={10}
                        helperText={t("specialties-pricing-upload-hint")}
                    />
                </div>
            </div>
        </SectionCard>
    )
}

export default EditSpecialties

